import sessionStore from 'client/Session/SessionStore';

import {resource} from '@albert-io/json-api-framework/request/builder';

export const getStudentSubmissionQuestionSetsQuery = (assignmentId, questionId, classroomId) => {
  const query = resource('question_sets_v1')
    .mandarkEndpoint(['assignments_v3', assignmentId, 'question_sets_v1'])
    .sort('meta.assignment_position')
    .include('subject_v2')
    .include('questions_v3.standards_v1.standard_set_v1')
    .include('questions_v3.question_set_v1.tags_v1')
    .withMeta('question_set_v1,question_v3,standard_v1')
    .customQuery({
      meta: {
        context: {
          user: {
            id: sessionStore.getUserId(),
            role: 'teacher',
            personalization_settings: true
          },
          assignment: {
            id: assignmentId
          },
          classroom: {
            id: classroomId
          }
        }
      },
      page: {
        id: questionId,
        fallback_page: 1
      }
    });

  return query;
};

// This is used for populating guesses
export const getStudentAssignmentQuery = ({assignmentId, studentId}) => {
  return resource('assignment_v3')
    .mandarkEndpoint(['assignments_v3', assignmentId])
    .include('classrooms_v1')
    .include('students_v2', studentId)
    .include('question_sets_v1')
    .include('guesses_v1.question_v3')
    .filter({
      included: {
        students_v2: {
          id: studentId
        },
        guesses_v1: {
          question_v3: {
            id: {
              null: false
            }
          },
          student_v2: {
            id: studentId
          }
        }
      }
    });
};

export const getAssignmentsQuery = (assignmentId, studentId, classroomId) => {
  const query = resource('assignments_v3')
    .mandarkEndpoint(['assignments_v3', assignmentId])
    .customQuery(
      {
        meta: {
          context: {
            student: {
              id: studentId
            },
            user: {
              id: studentId
            },
            classroom: {
              id: classroomId
            }
          }
        }
      },
      studentId
    )
    .include('classrooms_v1')
    .withMeta('assignment_v3');
  return query;
};
